var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"app",attrs:{"fluid":""}},[_c('v-erro',{attrs:{"icone":_vm.icone,"nomeDoErro":_vm.nomeDoErro,"mensagemDeErro":_vm.mensagemDeErro}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }